import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Percent, LinkIcon, ShieldCheck } from "lucide-react";
import { submitLead } from "../lib/api";
import Seo from "../components/Seo";
import Header from "../components/Header";
import Footer from "../components/Footer";

const empty = {
  nom: "", email: "", telephone: "", situation: "createur",
  plateformes: "", audience: "moins-5k", lien: "", message: "",
};

const PROFILS = [
  { v: "createur", l: "Créateur / créatrice de contenu" },
  { v: "agence", l: "Agence marketing / communication" },
  { v: "consultant", l: "Consultant·e / freelance" },
  { v: "media", l: "Média / newsletter / communauté" },
  { v: "autre", l: "Autre" },
];

const AUDIENCES = [
  { v: "moins-5k", l: "Moins de 5 000" },
  { v: "5k-20k", l: "5 000 à 20 000" },
  { v: "20k-100k", l: "20 000 à 100 000" },
  { v: "plus-100k", l: "Plus de 100 000" },
];

const POINTS = [
  { icon: Percent, t: "Commission 15 %", d: "Une commission sur les ventes que vous apportez, hors programme pilote." },
  { icon: LinkIcon, t: "Lien de suivi dédié", d: "Un lien personnel pour recommander VIRALYA à votre audience." },
  { icon: ShieldCheck, t: "Suivi transparent", d: "Attribution claire et paiement en CHF, conforme à la LPD." },
];

export default function Affiliation() {
  const [form, setForm] = useState(empty);
  const [status, setStatus] = useState(null);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault(); setStatus("loading");
    try { await submitLead({ type: "affiliation", ...form }); setStatus("ok"); setForm(empty); }
    catch { setStatus("err"); }
  };

  return (
    <div>
      <Seo path="/affiliation" />
      <Header />
      <main className="page">
        <div className="container page-narrow">
          <Link to="/" className="back-link"><ArrowLeft size={15} /> Accueil</Link>
          <span className="eyebrow"><span className="sq" />Affiliation</span>
          <h1 className="h2" style={{ marginBottom: "0.5rem" }}>Devenez affilié VIRALYA</h1>
          <p className="lead" style={{ marginBottom: "1.5rem" }}>Recommandez VIRALYA à votre audience et touchez une commission de 15 % sur les ventes que vous apportez. Candidature en quelques minutes.</p>

          <div className="af-points" data-testid="affiliation-points">
            {POINTS.map(({ icon: Icon, t, d }) => (
              <div className="glass card" key={t}>
                <span className="af-ico"><Icon size={18} /></span>
                <h3 style={{ margin: "0.75rem 0 0.35rem", fontSize: "1.05rem" }}>{t}</h3>
                <p style={{ color: "var(--text-secondary)", fontSize: "0.9rem", margin: 0 }}>{d}</p>
              </div>
            ))}
          </div>

          <div className="glass card" style={{ borderLeft: "4px solid var(--v-accent)", margin: "1.5rem 0" }}>
            <p style={{ margin: 0 }}><strong>Candidature étudiée manuellement.</strong> Nous vérifions que votre audience correspond à VIRALYA. Réponse sous 48 h ouvrées — aucun engagement, aucune carte demandée.</p>
          </div>

          {status === "ok" ? (
            <div className="glass card center" data-testid="affiliation-success"><p className="lead">Candidature reçue. Nous revenons vers vous sous 48 h ouvrées avec la suite.</p></div>
          ) : (
            <form className="glass card" onSubmit={submit} data-testid="affiliation-form">
              <div className="form-grid">
                <div className="field"><label>Nom complet</label><input required value={form.nom} onChange={set("nom")} data-testid="affiliation-nom" /></div>
                <div className="field"><label>E-mail</label><input required type="email" value={form.email} onChange={set("email")} data-testid="affiliation-email" /></div>
                <div className="field"><label>Téléphone</label><input value={form.telephone} onChange={set("telephone")} data-testid="affiliation-tel" /></div>
                <div className="field"><label>Votre profil</label>
                  <select value={form.situation} onChange={set("situation")} data-testid="affiliation-profil">
                    {PROFILS.map((o) => <option key={o.v} value={o.v}>{o.l}</option>)}
                  </select>
                </div>
                <div className="field"><label>Plateformes principales</label><input placeholder="Instagram, TikTok, LinkedIn, newsletter…" value={form.plateformes} onChange={set("plateformes")} data-testid="affiliation-plateformes" /></div>
                <div className="field"><label>Taille d'audience</label>
                  <select value={form.audience} onChange={set("audience")} data-testid="affiliation-audience">
                    {AUDIENCES.map((o) => <option key={o.v} value={o.v}>{o.l}</option>)}
                  </select>
                </div>
                <div className="field full"><label>Lien principal (profil, site ou chaîne)</label><input placeholder="https://" value={form.lien} onChange={set("lien")} data-testid="affiliation-lien" /></div>
                <div className="field full"><label>Comment comptez-vous parler de VIRALYA ?</label><textarea rows={4} value={form.message} onChange={set("message")} data-testid="affiliation-message" /></div>
              </div>
              <button className="btn btn--primary" style={{ marginTop: "1.25rem" }} disabled={status === "loading"} data-testid="affiliation-submit">
                {status === "loading" ? "Envoi…" : "Envoyer ma candidature"}
              </button>
              {status === "err" && <p className="form-status err">Un problème est survenu. Merci de réessayer.</p>}
              <p style={{ marginTop: "1rem", fontSize: "0.82rem", color: "var(--text-secondary)" }}>
                En envoyant ce formulaire, vous acceptez le traitement de vos données conformément à notre <Link to="/legal/confidentialite" className="af-link">politique de confidentialité (LPD)</Link>.
              </p>
            </form>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
